 <template>
  <article class="indexes">
      <Recap :indexes="sectorIndexes" :sector="sector" :isResultPage="true" v-if="isResult" />
      <h5 v-if="!isResult" class="indexes__title">
        {{  $t('message.constructionParams.indexes.results') }}
      </h5>
      <ul class="indexes__list">
        <template v-for="(indexItem, i) of indexes">
          <li v-if="indexItem.value" :class="`${indexItem.label}-${indexItem.type}`" :key="i">
            <h6 class="indexes__subtitle" v-if="indexItem.mainTitle">{{ indexItem.mainTitle }}</h6>
            <p class="indexes__list-item">
              <span class="text">
              {{ indexItem.title }}<sub class="sub">{{ indexItem.subtitle }}</sub>
            </span>
              <span class="value">{{ indexItem.value }}</span>
              <span v-if="indexItem.icon" class="icon">
                <tippy interactive placement="top" animation="shift-toward" arrow="false" :maxWidth="300">
                  <template #trigger>
                    <span class="tooltip__title"></span>
                  </template>
                  <span class="tooltip__body-text">
                    {{ $t('message.constructionParams.indexes.tooltip.text') }}
                    <span class="tooltip__body-link">
                      <a :href="$t('message.constructionParams.indexes.tooltip.link')" target="_blank">
                      {{ $t('message.constructionParams.indexes.tooltip.linkText') }}
                    </a>
                    </span>
                  </span>
                </tippy>
              </span>
            </p>
          </li>
        </template>
      </ul>
  </article>
</template>

<script>
import Recap from '@/components/dump/RecapComponent'

export default {
  name: 'Index',
  components: { Recap },
  props: ['sectorIndexes', 'isResult', 'sector'],
  computed: {
    isRwTested() {
      return this.sectorIndexes.isTested
    },
    isCalculatingPROIndexes() {
      return !this.isResult
    },
    indexes() {
      const indexes = [
        {
          label: 'rw',
          type: 'required',
          title: this.$t('message.constructionParams.indexes.rw'),
          subtitle: this.$t('message.constructionParams.indexes.subs.rw'),
          value: null
        },
        {
          label: 'rw',
          type: 'calculated',
          title: this.$t(`message.constructionParams.indexes.calculated.${this.isRwTested ? 'rw-tested' : 'rw'}`),
          subtitle: this.$t(`message.constructionParams.indexes.calculated.subs.${this.isRwTested ? 'rw-tested' : 'rw'}`),
          value: null
        },
        {
          label: 'rw',
          type: 'rwDown',
          title: this.$t('message.constructionParams.indexes.w'),
          subtitle: this.$t(`message.constructionParams.indexes.rwDown.subs.rw`),
          value: null,
          icon: true
        },
        {
          label: 'lnw',
          type: 'required',
          title: this.$t('message.constructionParams.indexes.lnw'),
          subtitle: this.$t('message.constructionParams.indexes.subs.lnw'),
          value: null
        },
        {
          label: 'lnw',
          type: 'calculated',
          title: this.$t('message.constructionParams.indexes.calculated.lnw'),
          subtitle: this.$t('message.constructionParams.indexes.calculated.subs.lnw'),
          value: null
        }
      ]

      Object.entries(this.sectorIndexes)
        .filter(([, value]) => value !== null)
        .forEach(([type, value]) => {
          indexes.forEach((index) => {
            if (index.type === type && (value?.[index.label] || (typeof value === 'number' && value))) {
              index.subtitle = index.subtitle.replace(' ', '\u00A0')
              index.value = `${value[index.label] ?? value} ${this.$t('message.units.dB')}`
            }
          })
        })

      return indexes.map((indexItem) => this.isCalculatingPROIndexes ? this.getWithTitles(indexItem) : indexItem)
    }
  },
  methods: {
    getWithTitles(indexObj) {
      return {
        ...indexObj,
        title: indexObj.title.replace(/^.+,/, '').trim(),
        mainTitle: this.$t(`message.constructionParams.indexes.${indexObj.type}Title`)
      }
    }
  }
}
</script>

<style scoped lang="sass">
.indexes
  width: 100%
  &:has(.indexes__list:not(:empty))
    margin: 0 0 rem(30)
  &__title
    margin: 0 0 rem(20)
    font-weight: 600
    line-height: 1.3
  &__list
    display: flex
    gap: 20px
    +media((flex-wrap: (0: wrap, 1000: nowrap)))
    & li:not(:has(.indexes__subtitle))
      width: 100%
      display: flex
    &-item
      width: 100%
      display: flex
      justify-content: space-between
      align-items: center
      gap: rem(10)
      padding: rem(18) rem(20)
      @extend %18
      line-height: 1.3
      color: $text-gray
      border-radius: $radius
      background: $grey-fill
      .text
        flex-grow: 1
        margin: 0
        text-align: left
      .value
        flex-shrink: 0
        color: $main-text
  &__subtitle
    margin: 0 0 rem(8)
  &__list:has(.indexes__subtitle)
    display: grid
    grid-template-columns: 1fr
    grid-template-rows: auto
    grid-gap: 0 rem(10)
    &:has(.rw-calculated)
      +media((grid-template-columns: (0: 1fr, 540: repeat(2, 1fr))))
    &:has(.rw-rwDown)
      +media((grid-template-columns: (0: 1fr, 1153: repeat(3, 1fr))))
  .icon
    order: 4
    .tooltip
      &__title
        display: flex
        width: rem(20)
        height: rem(20)
        cursor: pointer
        background: url(~@/assets/img/icons/tooltip-icon.svg) no-repeat center
</style>
